import { forwardRef } from 'react';

import * as Styled from './Carousel.styles';

const CarouselWrapper = forwardRef(({ className, ...props }, ref) => {
  return <Styled.Wrapper ref={ref} className={className} {...props} />;
});

CarouselWrapper.displayName = 'CarouselWrapper';

export default CarouselWrapper;
